module.exports = __webpack_public_path__ + "static/media/user_details_inactive.d501f8d0.svg";